<template>
    <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="content">
    
            <div class="card">
                <FlashMessage :position="'right top'"></FlashMessage>
    
                <div class="card-header">
                    <h4 class="title">Add Promotion</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="update">
                        <div class="row">
    
                            <div class="col-md-5">
                                <label>Promotion<em style="color:red">*</em></label>
                                <input class="form-control" v-model.trim="$v.promotiondata.promotion.$model" type="text" label="Promotion" placeholder="Enter Promotion" />
                                <div class="error" v-if="submitted && !$v.promotiondata.promotion.required">Please enter promotion</div>
    
                            </div>
                            <!-- </div> -->
    
                            <!-- <div class="row"> -->
                            <div class="col-md-5">
                                <label>Status<em style="color:red">*</em></label>
                                <select class="form-control" v-model.trim="$v.promotiondata.status.$model">
                                    <option disabled>Select status</option>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                                </select>
                                <div class="error" v-if="submitted && !$v.promotiondata.status.required">Please select status</div>
    
                            </div>
    
                        </div>
    
                        <div class="text">
                            <button type="submit" class="btn btn-secondary dashboard">Update</button>&nbsp;
                            <router-link to="/admin/dashboard/promotion"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>
    
                        </div>
    
                    </form>
                </div>
            </div>
    
        </div>
        <content-footer></content-footer>
    </div>
    </template>
    
    <script>
    import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
    import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
    import ValidationError from "src/components/UIComponents/ValidationError.vue";
    import {
        required,
        minLength,
        maxLength,
        between,
    } from "vuelidate/lib/validators";
    export default {
        name: 'editPromotion',
        components: {
            TopNavbar,
            ContentFooter,
        },
    
        data() {
            return {
                submitted: false,
    
                promotiondata: {
                    promotion: '',
                    status: 1,
                }
            }
        },
    
        validations: {
            promotiondata: {
                promotion: {
                    required,
                },
                status: {
                    required,
                },
            }
        },
    
        methods: {
            update() {
                this.submitted = true;
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                } else {
                    this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/promotion/update/` + this.$route.params.id, this.promotiondata)
                        .then(({
                            data
                        }) => {
                            this.flashMessage.success({
                                message: 'Promotion Updated Successfully '
                            });
                            this.$router.push('/admin/dashboard/promotion');
                        })
                    // .catch((error) => {
                    //     console.log(error);
                    // });
                }
            }
        },
    
        async mounted() {
            const promotiondata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/promotion/edit/` + this.$route.params.id);
            this.promotiondata = promotiondata.data.data;
        },
    
    };
    </script>
    
    <style lang="scss">
    </style>
    